import CryptoJS from "crypto-js";
//https://brunoseco.medium.com/criptografando-informa%C3%A7%C3%B5es-no-localstorage-e-cookie-94f5c272543b
//https://stackoverflow.com/questions/58621582/encrypt-by-javascript-and-decrypt-by-java
//https://www.oodlestechnologies.com/blogs/encrypt-text-in-javascript-and-decrypt-in-java/
//decrypt javascript in java
export default class CacheCrypto {

    constructor() {                
    }   

    getSalt(key) {
        return key + 'iKlnOywPoDcNeNyh&7c97ixysnXTtRtO';
    }

    configData(val) {
        let index = val.lastIndexOf('==');
        let item = { data: val, ini: '' };  
        if(index > 0) {
            item.data = val.replace('==', '');
            item.ini = 'eq2';
        } else {
            index = val.lastIndexOf('=');
            if(index > 0) {
                item.data = val.replace('=', '');
                item.ini = 'eq1';
            }
        }
        return JSON.stringify(item);
    }

    get(key) {    
        let result = sessionStorage.getItem(key);
        if (result) {
            let item = JSON.parse(result);
            if(item.ini == 'eq2') {
                item.data += '==';
            } else if(item.ini == 'eq1') {
                item.data += '=';
            }
            try {
                let _salt = this.getSalt(key);
                let bytes = CryptoJS.AES.decrypt(item.data, _salt);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);             
                return originalText;
            } catch (e) {
                return item.data;
            }
        } else {
            result = null;
        }
        return result;
    }

    add(key, data) {   
        let _salt = this.getSalt(key);          
        let _newdata = CryptoJS.AES.encrypt(data, _salt).toString(); 
        sessionStorage.setItem(key, this.configData(_newdata));
    }
}